import React from 'react';

const metrics = [
  { label: 'Position Size', value: '$2.5M' },
  { label: 'Portfolio Weight', value: '3.2%' },
  { label: 'Beta', value: '1.15' },
  { label: 'VaR 95%', value: '$125K' },
  { label: 'Max Drawdown', value: '-8.5%', negative: true },
  { label: 'Liquidity Days', value: '2.3' },
];

const Preview: React.FC = () => (
  <div className="h-full bg-white p-4 flex flex-col">
    <div className="text-sm font-semibold text-gray-700 mb-3">Position Risk</div>
    <div className="flex-1 overflow-hidden">
      <div className="grid grid-cols-2 gap-3">
        {metrics.map(m => (
          <div key={m.label} className="bg-gray-50 rounded-lg p-3">
            <div className="text-[10px] text-gray-400 uppercase tracking-wide mb-1">{m.label}</div>
            <div className={`text-lg font-bold ${m.negative ? 'text-red-500' : 'text-gray-800'}`}>
              {m.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Preview;
